/*
 * @Author: your name
 * @Date: 2021-06-24 11:07:32
 * @LastEditTime: 2021-12-07 11:18:22
 * @LastEditors: your name
 * @Description: yang
 * @FilePath: \web_bank\src\router\index.js
 * 可以输入预定的版权声明、个性签名、空行等
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import bind from '../views/bind'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/bind',
    name: '绑定',
    component: bind
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/manualBind',
    name: 'manualBind',
    component: () => import(/* webpackChunkName: "about" */ '../views/manualBind.vue')
  },
  {
    path: '/menu',
    name: 'menu',
    component: () => import(/* webpackChunkName: "about" */ '../views/menu.vue')
  },
  {
    path: '/recharge',
    name: '充值',
    component: () => import(/*  消息中心首页 */ '../views/one_card/recharge.vue'),
  },
  {
    path: '/balance',
    name: '一卡通',
    component: () => import(/* */ '../views/one_card/balance.vue'),
    children:[
      {
        path: 'expensesRecord',
        name: '消费记录',
        component: () => import(/*  消息中心首页 */ '../views/one_card/expensesRecord.vue'),
      },
    ],
  },
  {
    path: '/setting',
    name: '设置',
    component: () => import(/*  消息中心首页 */ '../views/set.vue'),
  },
  {
    path: '/expensesRecord',
    name: '消费记录',
    component: () => import(/*  消息中心首页 */ '../views/one_card/expensesRecord.vue'),
  },
  {
    path: '/rechargeRecord',
    name: '充值记录',
    component: () => import(/*  消息中心首页 */ '../views/one_card/rechargeRecord.vue'),
  },
  {
    path: '/leave',
    name: '请假页面',
    component: () => import(/*  消息中心首页 */ '../views/leave/index.vue'),
  },
  {
    path: '/addLeave',
    name: '老师请假页面',
    component: () => import(/*  消息中心首页 */ '../views/leave/addLeave.vue'),
  },
  {
    path: '/successLeave',
    name: '请假成功页面',
    component: () => import(/*  消息中心首页 */ '../views/leave/successLeave.vue'),
  },
  {
    path: '/addLeaveStudent',
    name: '家长请假页面',
    component: () => import(/*  消息中心首页 */ '../views/leave/addLeaveStudent.vue'),
  },
  {
    path: '/people',
    name: '家长选择请假人页面',
    component: () => import(/*  消息中心首页 */ '../views/leave/people.vue'),
  },
  {
    path: '/class',
    name: '老师管理的班级页面',
    component: () => import(/*  消息中心首页 */ '../views/leave/class.vue'),
  },
  {
    path: '/teacherPeople',
    name: '老师选择请假人页面',
    component: () => import(/*  消息中心首页 */ '../views/leave/teacherPeople.vue'),
  },
  {
    path: '/shenpi',
    name: '审批人页面',
    component: () => import(/*  消息中心首页 */ '../views/leave/shenpi.vue'),
  },
  {
    path: '/teacherLeave',
    name: '老师请假页面',
    component: () => import(/*  消息中心首页 */ '../views/leave/teacherLeave.vue'),
  },
  {
    path: '/examine',
    name: '老师审批页面',
    component: () => import(/*  消息中心首页 */ '../views/leave/examine.vue'),
  },
  {
    path: '/leaveDetails',
    name: '请假详情页面',
    component: () => import(/*  消息中心首页 */ '../views/leave/leaveDetails.vue'),
  },
]

const router = new VueRouter({
  mode: 'hash',
  // base: process.env.BASE_URL,
  routes
})
router.beforeEach(async (to, from, next) => {
  console.log(to)
  console.log(from)
  if(to.fullPath == "/" && from.fullPath == "/" ){
    console.log(".........")
    // alert("ppppp")
    sessionStorage.setItem("logo", "1")
    // window.history.go(-2)
    // next();
    // 导航栏左侧返回按钮点击事件
    // document.addEventListener('back', function (e) {
    //   alert('自定义返回');
    //   e.preventDefault(); //阻止默认返回行为
    //   var userAgent = navigator.userAgent;
    //   if (userAgent.indexOf("Firefox") != -1 || userAgent.indexOf("Chrome") !=-1) {
    //     window.open('','_self').close()  
    //   }else {
    //     window.opener = null;
    //     window.open("about:blank", "_self");
    //     window.close();
    //   };
    // }, false);
    next();
  }else{
    next();
    sessionStorage.setItem("logo", "0")
  }
  // if (to.matched.some(record => record.meta.auth) && to.meta.auth) { // 判断该路由是否需要登录权限
  //   let token = localStorage.getItem('token');
  //   if (token) { // 获取当前的 token 是否存在
  //     next()
  //   } else {
  //     // 不存在 token，需要重新认证
  //     next({
  //       path: '/auth/login',
  //       query: {
  //         redirect: to.fullPath
  //       }
  //     })
  //   }
  // }
 
});
export default router
